import { useState } from 'react';
import { AxiosPrivate, AxiosPublic } from '../utils/axios';
import { Utils, SubmissionType } from '@mvrb-frontend/shared-ui';
import EngagementModel from '../models/EngagementModel';
import { EngagementLocationModel, ResponseException } from '../models';

export const useGetEngagementOrgs = () => {
  const [engagementData, setEngagementData] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
  const [successSubmit, setSuccessSubmit] = useState<boolean>(false);
  const [engagementList, setEngagementList] = useState<any>([]);
  const [count, setCount] = useState<any>(0);
  const [submitEngagementErrors, setSubmitEngagementErrors] = useState<string[]>([]);
  const [engagementSubmisisonType, setEngagementSubmissionType] = useState<SubmissionType>();

  const getEngagementOrgs = async (queryParams?: any) => {
    setIsFetching(true);
    try {
      const { data } = await AxiosPublic.get(`/organizations/engagement/list`, {
        params: { ...queryParams },
      });
      setEngagementList(data.engagementData.map(eng => new EngagementModel(eng)));
      setCount(data.dataCount);
    } catch (e) {
      setIsFetching(false);
    } finally {
      setIsFetching(false);
    }
  };

  const submitEngagementOrgs = async (values: any, submissionType: SubmissionType) => {
    try {
      setEngagementSubmissionType(submissionType);
      setIsSubmiting(true);

      switch (submissionType) {
        case SubmissionType.Add:
          await AxiosPrivate.post('/organizations/engagement/add', values);
          break;
        case SubmissionType.Update:
          await AxiosPrivate.patch('organizations/engagement/update', values);
          break;
        case SubmissionType.Delete:
          await AxiosPrivate.delete(`organizations/engagement/delete/${values}`);
          break;
      }
      setSubmitEngagementErrors([]);
      setSuccessSubmit(true);
    } catch (e) {
      setSuccessSubmit(false);
      setSubmitEngagementErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setIsSubmiting(false);
    }
  };

  const getEngagementData = async (values: any) => {
    try {
      setIsFetching(true);

      const { data } = await AxiosPrivate.get(`organizations/engagement/${values}`);
      data[0].location = data[0].location.split(',');

      if (Array.isArray(data[0]?.location)) {
        data[0].location = data[0].location.map(item => new EngagementLocationModel(item));
      }
      setEngagementData(data[0]);

      return data[0];
    } catch (e) {
      setIsFetching(false);
    } finally {
      setIsFetching(false);
    }
  };

  return {
    getEngagementOrgs,
    submitEngagementOrgs,
    getEngagementData,
    engagementData,
    isFetching,
    isSubmiting,
    engagementList,
    successSubmit,
    count,
    submitEngagementErrors,
    engagementSubmisisonType,
  };
};
